export default __webpack_public_path__ + "static/media/agen_referral_cara1.44e3a0cc.svg";